module.exports = __webpack_public_path__ + "img/Dandan Hamburger.d832ec18.svg";